import { render, staticRenderFns } from "./LinksGrid.vue?vue&type=template&id=663852ef&scoped=true&"
import script from "./LinksGrid.vue?vue&type=script&lang=js&"
export * from "./LinksGrid.vue?vue&type=script&lang=js&"
import style0 from "./LinksGrid.vue?vue&type=style&index=0&id=663852ef&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663852ef",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Container: require('/vercel/path0/components/general/Container.vue').default,SmallWithIcon: require('/vercel/path0/components/pageGridTiles/SmallWithIcon.vue').default,SmallWithImage: require('/vercel/path0/components/pageGridTiles/SmallWithImage.vue').default,LargeWithProductImage: require('/vercel/path0/components/pageGridTiles/LargeWithProductImage.vue').default,SelectableBgColor: require('/vercel/path0/components/general/SelectableBgColor.vue').default})
